<app-header></app-header>
<div class="main-container d-flex">
    <app-sidebar></app-sidebar>
    <div class="container-fluid h-100p overflow-y-scroll directory-page-shell" *ngIf="!isSubmissionSuccess">
        <div class="directory-container">
            <div class="row align-items-center py-4">
                <div class="col-md-6">
                    <div class="directory-title text-dblack">Nodal Officers Contact List</div>
                    <!-- <p class="directory-subtitle">Verified contacts submitted by users and maintained by the admin.</p> -->
                </div>
                <div class="col-md-6 text-end header-actions">
                    <a class="btn btn-dark-custom directory-nav-btn directory-nav-leaderboard" [routerLink]="['/leaderboard']" role="button">
                        <i class="fas fa-trophy"></i> Leaderboard
                    </a>
                    <a class="btn btn-dark-custom directory-nav-btn directory-nav-contributions" [routerLink]="['/my-contributions']" role="button">
                        My Contributions
                    </a>
                    <button class="btn btn-success-custom directory-nav-btn directory-nav-add-contact" (click)="openModal()">
                        Add Contact
                    </button>
                </div>
            </div>
            <div class="directory-page">
                <!-- Stats Bar -->
                <div class="stats-bar">
                    <div class="stat-card stat-card-clickable" (click)="setOperatorTypeFromStats('ALL')">
                        <div class="stat-card-inner">
                            <div class="stat-icon-box" [style.background]="'rgba(148,163,184,.08)'">
                                <i class="fas fa-layer-group" [style.color]="'#94a3b8'"></i>
                            </div>
                            <div>
                                <div class="stat-value">{{ allOperatorsCount | number }}</div>
                                <div class="stat-label">All Operators</div>
                            </div>
                        </div>
                    </div>

                    <div class="stat-card stat-card-clickable" (click)="setOperatorTypeFromStats('ISP')">
                        <div class="stat-card-inner">
                            <div class="stat-icon-box" [style.background]="getOperatorTypeBgLight('ISP')">
                                <i class="fas fa-wifi" [style.color]="getOperatorTypeHex('ISP')"></i>
                            </div>
                            <div>
                                <div class="stat-value">{{ ispOperatorsCount | number }}</div>
                                <div class="stat-label">ISP</div>
                            </div>
                        </div>
                    </div>

                    <div class="stat-card stat-card-clickable" (click)="setOperatorTypeFromStats('BANK')">
                        <div class="stat-card-inner">
                            <div class="stat-icon-box" [style.background]="getOperatorTypeBgLight('BANK')">
                                <i class="fas fa-landmark" [style.color]="getOperatorTypeHex('BANK')"></i>
                            </div>
                            <div>
                                <div class="stat-value">{{ bankOperatorsCount | number }}</div>
                                <div class="stat-label">Bank</div>
                            </div>
                        </div>
                    </div>

                    <div class="stat-card stat-card-clickable" (click)="setOperatorTypeFromStats('E-WALLET')">
                        <div class="stat-card-inner">
                            <div class="stat-icon-box" [style.background]="getOperatorTypeBgLight('E-WALLET')">
                                <i class="fas fa-wallet" [style.color]="getOperatorTypeHex('E-WALLET')"></i>
                            </div>
                            <div>
                                <div class="stat-value">{{ ewalletOperatorsCount | number }}</div>
                                <div class="stat-label">E-Wallet</div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Search and Filter Section -->
                <div class="search-filter-section">
                    <div class="search-row">
                        <div class="filter-field search-input-wrapper">
                            <label class="search-label" for="operatorSearch">Search</label>
                            <div class="search-icon-wrap">
                                <i class="fas fa-search search-icon"></i>
                                <input id="operatorSearch" type="text" class="form-control dark-search-input" placeholder="Search operator name" [(ngModel)]="searchQuery" (keyup.enter)="onSearch()" (input)="onSearchInput()">
                            </div>
                        </div>

                        <div class="filter-field operator-type-field">
                            <label class="search-label" for="typeSelect">Operator Type</label>
                            <select id="typeSelect" class="form-control dark-search-input operator-select" [(ngModel)]="selectedOperatorType" (change)="onOperatorTypeChange()">
                                <option value="ALL">All Types</option>
                                <option *ngFor="let operatorType of operatorTypes" [ngValue]="getOperatorTypeName(operatorType)">
                                    {{ getOperatorTypeName(operatorType) }}
                                </option>
                            </select>
                        </div>

                        <div class="filter-field date-filter-wrapper">
                            <label class="search-label" for="startDate">Start Date</label>
                            <input type="date" id="startDate" class="form-control dark-search-input date-input" [(ngModel)]="startDate" (change)="onDateChange()">
                        </div>

                        <div class="filter-field date-filter-wrapper">
                            <label class="search-label" for="endDate">End Date</label>
                            <input type="date" id="endDate" class="form-control dark-search-input date-input" [(ngModel)]="endDate" (change)="onDateChange()">
                        </div>

                        <div class="filter-actions">
                            <button class="btn btn-search-action" (click)="onSearch()">
                                <i class="fas fa-search"></i>
                                <span>Search</span>
                            </button>
                            <button class="btn btn-reset-action" (click)="resetFilters()">
                                <i class="fas fa-rotate-left"></i>
                                <span>Reset</span>
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Results info -->
                <div class="results-info-row">
                    <p class="results-info" *ngIf="isLoading">Loading…</p>
                    <p class="results-info" *ngIf="!isLoading">{{ getResultsInfoText() }}</p>
                    <div class="results-hint">
                        <i class="fas fa-info-circle"></i>
                        Click a card to view details
                    </div>
                </div>

                <!-- Directory Results or Detail View -->
                <div class="directory-results" *ngIf="!selectedOrg">
                    <!-- Loading State -->
                    <div class="empty-state" *ngIf="isLoading">
                        <div class="spinner-border text-secondary mb-3" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                        <p class="empty-text">Loading directory data...</p>
                    </div>

                    <!-- Cards Grid -->
                    <div class="directory-card-grid" *ngIf="!isLoading && organizations.length > 0">
                        <div class="directory-card card-item" *ngFor="let org of organizations" (click)="openDetailView(org)">
                            <div class="directory-card-topbar" [style.background]="getCardTopGradient(org.type)"></div>

                            <div class="directory-card-body">
                                <div class="directory-card-header">
                                    <div class="operator-avatar" [ngStyle]="{ background: getOperatorTypeBgLight(org.type), color: getOperatorTypeHex(org.type) }">
                                        <img *ngIf="org.operatorLogoUrl" [src]="org.operatorLogoUrl" alt="" class="operator-avatar-img">
                                        <span *ngIf="!org.operatorLogoUrl" class="operator-avatar-initials">{{ getInitials(org.name) }}</span>
                                    </div>

                                    <div class="directory-card-title">
                                        <div class="directory-card-title-row">
                                            <h3 class="directory-card-org-name">{{ formatValue(org.name) }}</h3>
                                        </div>

                                        <div class="operator-type-badge-row mt-2" *ngIf="org.type">
                                            <span class="operator-type-badge" [ngClass]="getOperatorTypeBadgeClass(org.type)">
                                                <i [ngClass]="getOperatorTypeIconClass(org.type)"></i>
                                                {{ org.type }}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div class="directory-card-meta">
                                    <div class="directory-card-meta-row" *ngIf="org.officerName">
                                        <i class="fas fa-user"></i>
                                        <span class="truncate-text">{{ org.officerName }}</span>
                                    </div>
                                    <div class="directory-card-meta-row" *ngIf="org.email">
                                        <i class="fas fa-envelope"></i>
                                        <span class="truncate-text">{{ org.email }}</span>
                                    </div>
                                    <div class="directory-card-meta-row" *ngIf="org.phone">
                                        <i class="fas fa-phone-alt"></i>
                                        <span class="truncate-text">{{ normalizePhoneList(org.phone) }}</span>
                                    </div>
                                </div>

                                <div class="directory-card-footer">
                                    <span class="directory-card-updated">
                                        <i class="fas fa-clock"></i>
                                        Updated: {{ formatValue(org.updatedOn) }}
                                    </span>
                                    <span class="directory-card-view">
                                        View <i class="fas fa-chevron-right"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Pagination -->
                    <div class="pagination-bar" *ngIf="!isLoading && organizations.length > 0 && totalPages > 1">
                        <button class="pagination-btn" (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1">
                            <i class="fas fa-chevron-left"></i>
                        </button>

                        <ng-container *ngFor="let item of paginationItems">
                            <button *ngIf="item !== -1; else ellipsisTpl" class="pagination-btn" [class.active]="item === currentPage" (click)="goToPage(item)">
                                {{ item }}
                            </button>
                            <ng-template #ellipsisTpl>
                                <span class="pagination-ellipsis">…</span>
                            </ng-template>
                        </ng-container>

                        <button class="pagination-btn" (click)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages">
                            <i class="fas fa-chevron-right"></i>
                        </button>
                    </div>

                    <!-- Empty State -->
                    <div class="empty-state" *ngIf="!isLoading && organizations.length === 0">
                        <i class="fas fa-search empty-icon"></i>
                        <p class="empty-text">No organizations found</p>
                        <p class="empty-subtext">Try adjusting your filters or search query</p>
                    </div>
                </div>

                <!-- Drawer Detail View -->
                <div class="drawer-overlay" *ngIf="selectedOrg" (click)="closeDetailView()"></div>
                <div class="drawer-panel" *ngIf="selectedOrg">
                    <div class="drawer-header">
                        <div class="drawer-header-left">
                            <h2 class="drawer-details-title">{{ formatValue(selectedOrg.name) }}</h2>
                        </div>
                        <button class="drawer-close-btn" (click)="closeDetailView()" aria-label="Close detail view">×</button>
                    </div>

                    <div class="drawer-body">
                        <!-- Identity Section -->
                        <div class="drawer-identity-header">
                            <div class="drawer-identity-avatar" [ngStyle]="{
                                    background: getOperatorTypeBgLight(selectedOrg.type || selectedOrg.operatorType),
                                    color: getOperatorTypeHex(selectedOrg.type || selectedOrg.operatorType)
                                }">
                                <img *ngIf="selectedOrg.operatorLogoUrl" [src]="selectedOrg.operatorLogoUrl" alt="Operator logo" class="drawer-identity-avatar-img">
                                <span *ngIf="!selectedOrg.operatorLogoUrl">{{ getInitials(selectedOrg.name) }}</span>
                            </div>

                            <div class="drawer-identity-meta">
                                <h3 class="drawer-identity-name">{{ formatValue(selectedOrg.name) }}</h3>
                                <span class="drawer-operator-type-pill operator-type-badge" [ngClass]="getOperatorTypeBadgeClass(selectedOrg.type || selectedOrg.operatorType)" *ngIf="selectedOrg.type || selectedOrg.operatorType">
                                    <i [ngClass]="getOperatorTypeIconClass(selectedOrg.type || selectedOrg.operatorType)"></i>
                                    {{ formatValue(selectedOrg.type || selectedOrg.operatorType) }}
                                </span>
                            </div>
                        </div>

                        <div class="drawer-fields-group">
                            <div class="drawer-field-row">
                                <div class="drawer-field-icon-box"><i class="fas fa-user-check"></i></div>
                                <div class="drawer-field-content">
                                    <p class="drawer-field-label">Contributed By</p>
                                    <p class="drawer-field-value" [class.drawer-field-value-na]="!selectedOrg.contributerName || selectedOrg.contributerName === 'N/A'">
                                        {{ formatValue(selectedOrg.contributerName) }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <p class="drawer-section-title">IDENTITY</p>
                        <div class="drawer-fields-group">
                            <div class="drawer-field-row">
                                <div class="drawer-field-icon-box"><i class="fas fa-building"></i></div>
                                <div class="drawer-field-content">
                                    <p class="drawer-field-label">Operator Name</p>
                                    <p class="drawer-field-value">{{ formatValue(selectedOrg.operator || selectedOrg.name) }}</p>
                                </div>
                            </div>

                            <div class="drawer-field-row">
                                <div class="drawer-field-icon-box">
                                    <i [ngClass]="getOperatorTypeIconClass(selectedOrg.type || selectedOrg.operatorType)"></i>
                                </div>
                                <div class="drawer-field-content">
                                    <p class="drawer-field-label">Operator Type</p>
                                    <span class="drawer-operator-type-pill operator-type-badge" [ngClass]="getOperatorTypeBadgeClass(selectedOrg.type || selectedOrg.operatorType)" *ngIf="selectedOrg.type || selectedOrg.operatorType">
                                        <i [ngClass]="getOperatorTypeIconClass(selectedOrg.type || selectedOrg.operatorType)"></i>
                                        {{ formatValue(selectedOrg.type || selectedOrg.operatorType) }}
                                    </span>
                                    <p class="drawer-field-value drawer-field-value-na" *ngIf="!selectedOrg.type && !selectedOrg.operatorType">
                                        N/A
                                    </p>
                                </div>
                            </div>

                            <div class="drawer-field-row">
                                <div class="drawer-field-icon-box"><i class="fas fa-user"></i></div>
                                <div class="drawer-field-content">
                                    <p class="drawer-field-label">Nodal Officer Name</p>
                                    <p class="drawer-field-value">{{ formatValue(selectedOrg.officerName) }}</p>
                                </div>
                            </div>

                            <div class="drawer-field-row">
                                <div class="drawer-field-icon-box"><i class="fas fa-briefcase"></i></div>
                                <div class="drawer-field-content">
                                    <p class="drawer-field-label">Designation</p>
                                    <p class="drawer-field-value">{{ formatValue(selectedOrg.designation) }}</p>
                                </div>
                            </div>

                        </div>

                        <p class="drawer-section-title">CONTACT INFO</p>
                        <div class="drawer-fields-group">
                            <div class="drawer-field-row">
                                <div class="drawer-field-icon-box"><i class="fas fa-envelope"></i></div>
                                <div class="drawer-field-content">
                                    <p class="drawer-field-label">Email Address</p>
                                    <p class="drawer-field-value" [class.drawer-field-value-na]="!selectedOrg.email || selectedOrg.email === 'N/A'">
                                        {{ formatValue(selectedOrg.email) }}
                                    </p>
                                </div>
                                <button class="drawer-copy-btn" *ngIf="selectedOrg.email && selectedOrg.email !== 'N/A'" (click)="copyToClipboard(selectedOrg.email, $event)" aria-label="Copy email" title="Copy">
                                    <i class="fas fa-copy"></i>
                                </button>
                            </div>

                            <div class="drawer-field-row">
                                <div class="drawer-field-icon-box"><i class="fas fa-phone-alt"></i></div>
                                <div class="drawer-field-content">
                                    <p class="drawer-field-label">Phone Number</p>
                                    <p class="drawer-field-value" [class.drawer-field-value-na]="!selectedOrg.phone || selectedOrg.phone === 'N/A'">
                                        {{ formatValue(normalizePhoneList(selectedOrg.phone)) }}
                                    </p>
                                </div>
                                <button class="drawer-copy-btn" *ngIf="selectedOrg.phone && selectedOrg.phone !== 'N/A'" (click)="copyToClipboard(normalizePhoneList(selectedOrg.phone), $event)" aria-label="Copy phone" title="Copy">
                                    <i class="fas fa-copy"></i>
                                </button>
                            </div>

                            <div class="drawer-field-row">
                                <div class="drawer-field-icon-box"><i class="fas fa-map-pin"></i></div>
                                <div class="drawer-field-content">
                                    <p class="drawer-field-label">Address</p>
                                    <p class="drawer-field-value" [class.drawer-field-value-na]="!selectedOrg.address || selectedOrg.address === 'N/A'">
                                        {{ formatValue(selectedOrg.address) }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <p class="drawer-section-title">DATES</p>
                        <div class="drawer-fields-group">
                            <div class="drawer-field-row">
                                <div class="drawer-field-icon-box"><i class="fas fa-calendar-plus"></i></div>
                                <div class="drawer-field-content">
                                    <p class="drawer-field-label">Created On</p>
                                    <p class="drawer-field-value" [class.drawer-field-value-na]="!selectedOrg.createdOn || selectedOrg.createdOn === 'N/A'">
                                        {{ formatValue(selectedOrg.createdOn) }}
                                    </p>
                                </div>
                            </div>

                            <div class="drawer-field-row">
                                <div class="drawer-field-icon-box"><i class="fas fa-calendar-check"></i></div>
                                <div class="drawer-field-content">
                                    <p class="drawer-field-label">Updated On</p>
                                    <p class="drawer-field-value" [class.drawer-field-value-na]="!selectedOrg.updatedOn || selectedOrg.updatedOn === 'N/A'">
                                        {{ formatValue(selectedOrg.updatedOn) }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <!-- Officer history from `last_update` inside `/list-master-data` -->
                        <div class="drawer-officer-history" *ngIf="hasOfficerHistory">
                            <div class="drawer-officer-history-head">
                                <div class="drawer-officer-history-title-row">
                                    <i class="fas fa-history drawer-officer-history-icon" aria-hidden="true"></i>
                                    <span class="drawer-officer-history-title">Officer history</span>
                                </div>
                                <span class="drawer-officer-history-badge">{{ officerHistoryPreviousCount }} previous</span>
                            </div>

                            <div class="drawer-officer-history-timeline">
                                <div class="drawer-officer-history-line" aria-hidden="true"></div>
                                <div class="drawer-officer-history-items">
                                    <div class="drawer-officer-history-card" *ngFor="let entry of currentOfficerHistoryEntries">
                                        <span class="drawer-officer-history-dot" aria-hidden="true"></span>
                                        <div class="drawer-officer-history-card-inner">
                                            <div class="drawer-officer-history-card-top">
                                                <div class="drawer-officer-history-avatar" aria-hidden="true">
                                                    <i class="fas fa-user"></i>
                                                </div>
                                                <div class="drawer-officer-history-card-heading">
                                                    <p class="drawer-officer-history-name">{{ entry.officerName }}</p>
                                                    <p class="drawer-officer-history-role">{{ entry.designation }}</p>
                                                </div>
                                            </div>
                                            <div class="drawer-officer-history-contact" *ngIf="entry.email">
                                                <i class="fas fa-envelope"></i>
                                                <span>{{ entry.email }}</span>
                                            </div>
                                            <div class="drawer-officer-history-contact" *ngIf="entry.phone">
                                                <i class="fas fa-phone-alt"></i>
                                                <span>{{ normalizePhoneList(entry.phone) }}</span>
                                            </div>
                                            <div class="drawer-officer-history-chip" *ngIf="entry.replacedOn">
                                                <i class="fas fa-calendar-alt"></i>
                                                <span>Replaced on {{ entry.replacedOn }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="drawer-footer-actions">
                        <button type="button" class="drawer-action-btn drawer-action-btn-edit" (click)="openEditContactDialog()">
                            <i class="fas fa-pencil-alt"></i>
                            <span>Edit Record</span>
                        </button>
                        <button type="button" class="drawer-action-btn drawer-action-btn-share" (click)="shareContactFromDrawer()">
                            <i class="fas fa-share-alt"></i>
                            <span>Share</span>
                        </button>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<!-- Submission Success Screen -->
<div class="success-overlay" *ngIf="isSubmissionSuccess">
    <div class="success-container">
        <!-- Success Icon -->
        <div class="success-icon">
            <div class="success-icon-outer">
                <div class="success-icon-middle">
                    <div class="success-icon-inner">
                        <i class="fas fa-check"></i>
                    </div>
                </div>
            </div>
        </div>

        <!-- Success Message -->
        <h2 class="success-title text-dblack">Submission Sent!</h2>
        <p class="success-subtitle">Your contribution has been submitted for verification.</p>
        <p class="success-description">
            Credits will be added to your account once the admin approves<br class="d-none d-md-block"> the details.
        </p>

        <!-- What Happens Next Box -->
        <div class="info-box light-info-box">
            <h2 class="info-box-title">What happens next?</h2>
            <div class="info-item text">
                <span class="info-number">1.</span>
                <span class="info-text">Admin will review your submitted contact details</span>
            </div>
            <div class="info-item">
                <span class="info-number">2.</span>
                <span class="info-text">Verification typically takes 24-48 hours</span>
            </div>
            <div class="info-item">
                <span class="info-number">3.</span>
                <span class="info-text">You'll receive credits upon approval (2-10 credits)</span>
            </div>
            <div class="info-item">
                <span class="info-number">4.</span>
                <span class="info-text">Check "My Contributions" to track the status</span>
            </div>
        </div>

        <!-- Back Button -->
        <button class="back-button" (click)="backToDirectory()">
            <i class="fas fa-arrow-left"></i>
            Back to Directory
        </button>
    </div>
</div>